// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"f68ydOM"};